<template>
  <section>
    <div class="modal-body">
      <form @submit.prevent="validateForm" class="m-form m-form--state">
        <div class="m-portlet__body">
          <div v-if="!isProfile">
            <div class="form-group m-form__group row" :class="{'has-danger': errors.has('name')}">
              <div :class="validPermission('create','phrase') ? 'col-lg-11' : 'col-lg-12'">
                <label>{{'name' | translate | capitalize}}</label>
                <select v-model="model.name" id="name" name="name" class="form-control m-bootstrap-select m_selectpicker" data-live-search="true" :title="'select_an_option' | translate | capitalize" v-validate="'required'">
                  <option v-for="phrase in names" :key="phrase.key" :value="phrase.key">{{ phrase.value | translate | capitalize }}</option>
                </select>
              </div>
              <div v-if="validPermission('create','phrase')" class="col-lg-1">
              <label>&nbsp;</label>
                <a class="btn btn-outline-success m-btn m-btn--icon m-btn--icon-only m-btn--outline-2x" data-toggle="modal" data-backdrop="static" data-keyboard="false" @click="changeModalPhraseStatus(true)" href="">
                  <i class="flaticon-add"></i>
                </a>
              </div>
              <label v-show="errors.has('name')" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
              <span v-show="errors.has('name')" class="m-form__help m--font-danger">{{ errors.first('name') }}</span>
            </div>
          </div>
          <div v-else>
            <div class="form-group m-form__group" :class="{'has-danger':errors.has('name')}">
              <label>{{ 'name' | translate | capitalize }}</label>
              <input type="text" name="name" v-model="model.name" class="form-control form-control-danger m-input" v-validate="'required|min:3|max:70|alpha_spaces'">
              <span v-show="errors.has('name')" class="m-form__help m--font-danger">{{ errors.first('name') }}</span>
            </div>
          </div>
          <div v-if="isProfile" class="form-group m-form__group row">
            <div class="col-lg-6" :class="{'has-danger':errors.has('level')}">
              <label>{{ 'level' | translate | capitalize }}</label>
              <select v-model="model.level" id="level" name="level" class="form-control m-bootstrap-select m_selectpicker" :title="'select_an_option' | translate | capitalize" v-validate="'required'">
                <option v-for="level in levels" :key="level.id" :value="level.id">{{ level.name | translate | capitalize }}</option>
              </select>
              <span v-show="errors.has('level')" class="m-form__help m--font-danger">{{ errors.first('level') }}</span>
            </div>
            <div class="col-lg-6">
              <label>&nbsp;</label><br>
              <label class="m-checkbox m-checkbox--state-brand">
                <input v-model="model.is_receptionist" type="checkbox"> {{'is_receptionist' | translate | capitalize }}
                <span></span>
              </label>
            </div>
          </div>
          <div v-else class="form-group m-form__group" :class="{'has-danger':errors.has('code')}">
            <label>{{ 'code' | translate | capitalize }}</label>
            <input type="text" name="code" v-model="model.code" class="form-control form-control-danger m-input" v-validate="'required|numeric'">
            <span v-show="errors.has('code')" class="m-form__help m--font-danger">{{ errors.first('code') }}</span>
          </div>
          <div v-if="!isProfile" class="form-group m-form__group" :class="{'has-danger':errors.has('entity')}">
            <label>{{ 'entity' | translate | capitalize }}</label>
            <input type="text" name="entity" v-model="model.entity" class="form-control form-control-danger m-input" v-validate="'alpha_dash'">
            <span v-show="errors.has('entity')" class="m-form__help m--font-danger">{{ errors.first('entity') }}</span>
          </div>
          <div v-if="!isProfile" class="form-group m-form__group" :class="{'has-danger':errors.has('action')}">
            <label>{{ 'action' | translate | capitalize }}</label>
            <input type="text" name="action" v-model="model.action" class="form-control form-control-danger m-input" v-validate="'alpha_dash'">
            <span v-show="errors.has('action')" class="m-form__help m--font-danger">{{ errors.first('action') }}</span>
          </div>      
          <div class="form-group m-form__group" :class="{'has-danger': errors.has('description')}">
            <label>{{ 'description' | translate | capitalize }}</label>
            <textarea class="form-control form-control-danger m-input" v-model="model.description" name="description" rows="3" v-validate="'required'"></textarea>
            <span v-show="errors.has('description')" class="m-form__help m--font-danger">{{ errors.first('description') }}</span>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" id="closeModal" class="btn btn-secondary" :data-dismiss="openOutside ? '' : 'modal'" @click="resetForm">{{ 'cancel' | translate | capitalize }}</button>
      <button type="button" id="btn-saveform" class="btn btn-primary" @click="validateForm">{{ 'save' | translate | capitalize }}</button>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    props: { isEdit: Boolean, isProfile: Boolean, pModel: Object, openOutside: Boolean },
    data () {
      return {
        model: {
          is_receptionist: 0,
          state: 1
        },
        level_options: [],
        profile_options: [],
        permission_options: [],
        names: []
      }
    },
    created () {
      this.getOptions()
    },
    computed: {
      ...mapGetters({all_active_permissions: 'activatePermissions',
        all_active_profiles: 'activateProfiles',
        all_permissions: 'allPermissions',
        all_profiles: 'allProfiles',
        Profile: 'getIdEditProfile',
        Permission: 'getIdEditPermission',
        stateModal: 'getProfileModalStatus',
        showEditProfile: 'getIdEditProfile',
        editStatus: 'getEditStatus',
        levels: 'allLevels',
        modal_phrases: 'getModalPhraseStatus',
        permissions: 'getUserPermissions' })
    },
    methods: {
      ...mapActions(['savePermission', 'saveProfile', 'editPermission', 'editProfile',
        'addPermissionsToProfile', 'addProfilesToPermission', 'updateModalStatus',
        'updateEditStatus', 'phrasesLanguage', 'changeModalPhraseStatus', 'profiles']),
      validateForm (event) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$spinner.show()
            if (this.isEdit) {
              if (this.isProfile) {
                this.editProfile(this.model)
                  .then(() => {
                    document.getElementById('closeModal').click()
                    this.$toast('edit_profile_message')
                    this.$spinner.remove()
                  })
                  .catch(() => {
                    this.$toast('general_error', 4)
                    this.$spinner.remove()
                  })
              } else {
                this.editPermission(this.model)
                  .then(() => {
                    this.$toast('edit_permission_message')
                    this.$spinner.remove()
                    document.getElementById('closeModal').click()
                  })
                  .catch(() => {
                    this.$toast('general_error', 4)
                    this.$spinner.remove()
                  })
              }
            } else if (this.isProfile) {
              this.saveProfile(this.model).then((result) => {
                this.profiles()
                  .then(() => {
                    document.getElementById('closeModal').click()
                    this.$toast('new_profile_message')
                    this.$spinner.remove()
                  })
              }).catch((error) => {
                this.$toast('new_profile_error', 4)
                this.$spinner.remove()
                console.log(error)
              })
            } else {
              this.savePermission(this.model).then((result) => {
                document.getElementById('closeModal').click()
                this.$toast('new_permission_message', 1)
                this.$spinner.remove()
                console.log(result)
              }, error => {
                this.$toast('new_permission_error', 4)
                this.$spinner.remove()
                console.log(error)
              })
            }
          }
        })
      },
      resetForm () {
        this.updateEditStatus(false)
        this.updateModalStatus(false)
        this.model = { level: '', state: 1 }
      },
      getValues (array) {
        let result = []
        if (array) {
          array.forEach(elem => {
            result.push(elem.value)
          })
        }
        return result
      },
      getOptions () {
        this.phrasesLanguage(this.$i18n.locale)
          .then((result) => {
            this.names = result.data[0].phrases
          })
          .catch((result) => {
            console.log(result)
          })
      },
      validPermission (action, entity) {
        if (this.permissions.find(p => { return (p.action === action && p.entity === entity) })) {
          return true
        } else {
          return false
        }
      }
    },
    watch: {
      stateModal (newVal, oldVal) {
        const $ = window.$
        $('.m_selectpicker').selectpicker('refresh')
        if (oldVal === false && newVal === true) {
          this.errors.clear()
        } else {
          this.errors.clear()
        }
      },
      editStatus () {
        const $ = window.$
        this.$nextTick(() => {
          this.model = JSON.parse(JSON.stringify(this.pModel))
          $('.m_selectpicker').selectpicker('refresh')
          if (!this.isProfile) {
            $('#name').selectpicker('val', this.pModel.name)
          } else {
            $('#level').selectpicker('val', this.pModel.level)
          }
        })
      },
      all_active_profiles () {
        this.$nextTick(() => {
          this.all_active_profiles.forEach(elem => {
            this.profile_options.push({'value': elem.id, 'label': elem.name})
          })
        })
      },
      all_active_permissions () {
        this.$nextTick(() => {
          this.all_active_permissions.forEach(elem => {
            this.permission_options.push({'value': elem.id, 'label': elem.name})
          })
        })
      },
      modal_phrases (newVal, oldVal) {
        if (oldVal === true && newVal === false) {
          this.names = []
          this.getOptions()
        }
      }
    }
  }
</script>

<style scoped>
.dropdown.v-select.single.searchable {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// BaseForm.vue